export const AUTH_RETURN_KEY="shane_auth_return_to";

export const safeReturnPath=(value)=>{
  if(typeof value!=="string"||!value.startsWith("/")||value.startsWith("//"))return"/";
  const parsed=new URL(value,window.location.origin);
  if(parsed.origin!==window.location.origin)return"/";
  const path=`${parsed.pathname}${parsed.search}`;
  return path.startsWith("/sign-in")?"/":path;
};